var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogOut = function SvgLogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Log_Out_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.722 14.961v2.752a1.376 1.376 0 0 1-1.377 1.376H2.713a1.376 1.376 0 0 1-1.376-1.376V2.576A1.376 1.376 0 0 1 2.713 1.2h9.632a1.376 1.376 0 0 1 1.377 1.376v2.752",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.754 10.779h-6.296a1 1 0 0 1-1-1V7.816",
    stroke: "#14161A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.704 11.832 1.051-1.051-1.05-1.051",
    stroke: "#14161A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Log_Out_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14161A",
    d: "M0 0h20v20H0z"
  }))));
};
export { SvgLogOut as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxtYXNrIGlkPSJtYXNrMF8yMjY4XzEzMDg4IiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTkiIGhlaWdodD0iMjAiPgogICAgICAgIDxwYXRoIGQ9Ik0xMy43MjE2IDE0Ljk2MTFWMTcuNzEzM0MxMy43MjE2IDE4LjA3ODIgMTMuNTc2NiAxOC40MjgzIDEzLjMxODYgMTguNjg2M0MxMy4wNjA1IDE4Ljk0NDQgMTIuNzEwNSAxOS4wODk0IDEyLjM0NTUgMTkuMDg5NEgyLjcxMjc3QzIuMzQ3ODEgMTkuMDg5NCAxLjk5Nzc5IDE4Ljk0NDQgMS43Mzk3MiAxOC42ODYzQzEuNDgxNjUgMTguNDI4MyAxLjMzNjY3IDE4LjA3ODIgMS4zMzY2NyAxNy43MTMzVjIuNTc2MTJDMS4zMzY2NyAyLjIxMTE1IDEuNDgxNjUgMS44NjExMyAxLjczOTcyIDEuNjAzMDZDMS45OTc3OSAxLjM0NDk5IDIuMzQ3ODEgMS4yMDAwMSAyLjcxMjc3IDEuMjAwMDFIMTIuMzQ1NUMxMi43MTA1IDEuMjAwMDEgMTMuMDYwNSAxLjM0NDk5IDEzLjMxODYgMS42MDMwNkMxMy41NzY2IDEuODYxMTMgMTMuNzIxNiAyLjIxMTE1IDEzLjcyMTYgMi41NzYxMlY1LjMyODMzIgogICAgICAgICAgICAgIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICAgICAgICA8cGF0aCBkPSJNMTcuNzU0MiAxMC43Nzg5SDExLjQ1NzlDMTAuOTA2NSAxMC43Nzg5IDEwLjQ1ODUgMTAuMzMwOSAxMC40NTg1IDkuNzc5NTNWNy44MTUyNSIgc3Ryb2tlPSIjMTQxNjFBIgogICAgICAgICAgICAgIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgogICAgICAgIDxwYXRoIGQ9Ik0xNi43MDQxIDExLjgzMkwxNy43NTUyIDEwLjc4MDlMMTYuNzA0MSA5LjcyOTgiIHN0cm9rZT0iIzE0MTYxQSIgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgICAgICAgICAgICAgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICAgIDwvbWFzaz4KICAgIDxnIG1hc2s9InVybCgjbWFzazBfMjI2OF8xMzA4OCkiPgogICAgICAgIDxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0iIzE0MTYxQSIvPgogICAgPC9nPgo8L3N2Zz4K";